"use strict";
exports.__esModule = true;
exports.HubType = exports.PrismicHubType = void 0;
var PrismicHubType;
(function (PrismicHubType) {
    PrismicHubType["PRESS_RELEASE"] = "HUB Actualit\u00E9s";
    PrismicHubType["NEWSROOM"] = "HUB Newsroom";
    PrismicHubType["INVESTORS_PRESS_RELEASE"] = "[Investisseurs] - HUB Communiqu\u00E9s de presse";
    PrismicHubType["INVESTORS_PUBLICATION"] = "[Investisseurs] - HUB Publication";
})(PrismicHubType = exports.PrismicHubType || (exports.PrismicHubType = {}));
var HubType;
(function (HubType) {
    HubType["PRESS_RELEASE"] = "press-release";
    HubType["NEWSROOM"] = "newsroom";
    HubType["INVESTORS_PRESS_RELEASE"] = "investors-press-release";
    HubType["INVESTORS_PUBLICATION"] = "investors-publication";
})(HubType = exports.HubType || (exports.HubType = {}));
//# sourceMappingURL=hub-slice.js.map